@if(visible) {
<div class="loader-overlay">
    <div class="loader"></div>
</div>
}